import { ResponseService } from './response.service';
import { CoreService } from './core.service';
import { ReplaySubject } from 'rxjs/Rx';
import { User } from './../interfaces/user.model';
import { Response } from '@angular/http';
import { ApiService } from './api.service';
import { Injectable, EventEmitter, Output, OnInit } from '@angular/core';

@Injectable()
export class UserService {
  private oUser = new ReplaySubject(1);

  constructor(
    private apiService: ApiService,
    private coreService: CoreService,
    private responseService: ResponseService
  ) { }

  getUser(forceRefresh?: boolean) {
    if (!this.oUser.observers.length || forceRefresh || this.coreService.refresh) {
      this.apiService.get('/profile').subscribe(
        (response) => {
          const userData = this.responseService.success(false, response, 'user');
          this.oUser.next(userData);
        },
        (error) => {
          this.responseService.error(error);
          this.oUser.error(error);
          this.oUser = new ReplaySubject(1);
        }
      );
    }
    return this.oUser;
  }

  getAccount() {
    this.apiService.get('/account').subscribe(
      (response) => {
        const account = this.responseService.success(false, response, 'account');
        return account;
      },
      (error) => {
        this.responseService.error(error);
      }
    )
  }

  clearUser() {
    this.oUser = new ReplaySubject(1);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user.service.ts